<template>
  <section class="mobile-video-section">
    <div id="animated_div">
      <b-container>
      <b-row class="align-content-center">
        <b-col sm="12" md="12" lg="12">
            <div class="video-container" style="width: 100%">
              <video :src="videoUrl" controls poster="@/assets/img/poster-video.jpg" width="100%">
                Your browser does not support the video tag.
              </video>
            </div>
        </b-col>
      </b-row>
    </b-container>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      videoUrl: require('@/assets/video/back-to-the-star.mp4')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";
  .mobile-video-section{
    padding: 20px 0 40px 0;
    .video-container {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 аспектне відношення */
        padding-top: 30px;
        height: 0;
        overflow: hidden;
        @media screen and (min-width: 320px) {
          display:flex;
        }
        @media screen and (min-width: 768px) {
        display:none;
        }
        @media screen and (min-width: 1440px) {

        }
        @media screen and (min-width: 1920px) {
        }
        video {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          @media screen and (min-width: 320px) {
          }
          @media screen and (min-width: 768px) {
          }
          @media screen and (min-width: 1440px) {
          }
          @media screen and (min-width: 1920px) {
          }
        }
      }
  }
</style>
